import {importSwiper} from "./kp-util";

const gallery_blocks = document.querySelectorAll('.block--gallery')

if (gallery_blocks.length > 0) {
    importSwiper().then(({Swiper, Navigation}) => {
        gallery_blocks.forEach(block => {
            const gallery = block.querySelector('.swiper-gallery')
            const next = block.querySelector('.swiper-button-next')
            const prev = block.querySelector('.swiper-button-prev')

            new Swiper(gallery, {
                modules: [Navigation],
                loop: true,
                autoHeight: true,
                navigation: {nextEl: next, prevEl: prev}
            });
        })
    })
}

